module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "about"
    }
  }, [_c('navigation', {
    staticClass: "absolute"
  }), _vm._v(" "), _c('hero', {
    attrs: {
      "words": _vm.words,
      "subtitle": _vm.subtitle,
      "separator": false
    }
  }), _vm._v(" "), _c('bacon', {
    attrs: {
      "title": "About Me"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "description",
    domProps: {
      "innerHTML": _vm._s(_vm.description)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "icons"
  }, _vm._l((_vm.icons), function(icon, index) {
    return _c('span', [_c('div', {
      staticClass: "icon"
    }, [_c('img', {
      attrs: {
        "src": '/dist/' + icon.url
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(icon.text))])]), _vm._v(" "), (index != _vm.icons.length - 1) ? _c('div', {
      staticClass: "separator"
    }) : _vm._e()])
  })), _vm._v(" "), _c('bacon', {
    attrs: {
      "title": "Work With Me"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "services"
  }, _vm._l((_vm.services), function(service) {
    return _c('li', [_vm._v(_vm._s(service))])
  })), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": "https://drive.google.com/file/d/0B0uj_BDfRuwvcTg2NHJhMkxYbW8/view",
      "target": "_blank"
    }
  }, [_vm._v("Resume")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d3fd371","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/pages/about.vue
// module id = 157
// module chunks = 0